// extracted by mini-css-extract-plugin
module.exports = {"text-container":"VideoText_text-container__5nw7c","description":"VideoText_description__cxvYs","video-button":"VideoText_video-button__J5NA_"};